<template>
  <div class="system-home">
    <el-form
      :model="dataForm"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmit()"
    >
      <el-form-item label="工种" prop="companyCode">
        <el-tag
          v-for="item in typeList"
          :key="item.professionId"
          type="info"
          effect="plain"
          closable
          @close="handleClose(item,'type')"
          style="margin-right: 5px"
        >
          {{ item.professionName }}
        </el-tag>
        <el-button type="primary" size="mini" @click="addOrUpdateHandle(1)"
          >新增</el-button
        >
      </el-form-item>
      <el-form-item label="区域" prop="companyCode">
        <el-tag
          v-for="item in areaList"
          :key="item.districtId"
          type="info"
          effect="plain"
          closable
          @close="handleClose(item)"
          style="margin-right: 5px"
        >
          {{ item.districtName }}
        </el-tag>
        <el-button type="primary" size="mini" @click="addOrUpdateHandle(2)"
          >新增</el-button
        >
      </el-form-item>
    </el-form>

    <!-- 区域新增 -->
    <add-or-update
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @refreshDataList="getDataList"
      @refreshTypeList="getTypeList"
    ></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from "./comm/baseEdit.vue";
import { professionListData, districtList } from "@/api/list";
import { districtDelete, professionDelete } from "./api";
export default {
  components: {
    AddOrUpdate,
  },
  data() {
    return {
      dataForm: {},
      areaList: [],
      addOrUpdateVisible: false,
      typeList: [],
      type: 1,
    };
  },
  mounted() {
    this.getDataList();
    this.getTypeList();
  },
  methods: {
    // 区域列表
    getDataList() {
      districtList({
          page: 1,
          limit: 1000
      }).then(data => {
        if (data && data.code === 0) {
          this.areaList = data.page.list;
        } else {
          this.areaList = [];
          this.$message.error(data.msg);
        }
      });
    },
    // 工种列表
    getTypeList() {
     professionListData({
          page: 1,
          limit: 1000
      }).then(data => {
        if (data && data.code === 0) {
          this.typeList = data.page.list;
        } else {
          this.typeList = [];
          this.$message.error(data.msg);
        }
      });
    },
    // 新增
    addOrUpdateHandle(type) {
      this.type = type;
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(type);
      });
    },
    // 重置
    cleaList() {
      this.dataForm = {};
      this.pageIndex = 1;
      this.getDataList();
    },
    // 删除
    handleClose(tag,val) {
      this.$confirm("此操作将删除该标签, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.delArea(tag,val)
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 删除区域
    delArea(item,val) {
      let url = '';
      let params = [];
      if(val){
        // 工种
        professionDelete(
          [item.professionId],
        ).then( data => {
          if (data && data.code === 0) {
            this.getTypeList();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      }else{
        // 区域
        districtDelete(
          [item.districtId]
        ).then( data => {
          if (data && data.code === 0) {
            this.getDataList();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      }
    },
  },
};
</script>

<style>
.award-home {
  line-height: 1.5;
}
</style>